import { Component, OnInit } from '@angular/core';
import { setMaxListeners } from 'process';
import { Observable } from "rxjs";
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';


declare const Chart: any;
@Component({
  selector: 'g10-open-booking-summary',
  templateUrl: './open-booking-summary.component.html',
  styleUrls: ['./open-booking-summary.component.css']
})
export class OpenBookingSummaryComponent implements OnInit {
  pageNum=1;


//   chart_seatBookingCount: any = {
//     labels: ["Booking Seat" ,"Available Seat"], data: ["5","8"], 
// }

public searchedValue;

searchChangeObserver: any;




  public openBookingData = [
  
    {
      info: {
        name: 'Anna nagar'
      },
      vehicles: [
        {
          regno: "TN 06 A 7654",
          totalSeat: "12",
          filledSeat: "8",
          location: "Velachery"
        },
        {
          regno: "TN 16 A 0054",
          totalSeat: "12",
          filledSeat: "5",
          location: "Pallikaranai"
        },
      ]
    },
    {
      info: {
        name: 'Velachery'
      },
      vehicles: [
        {
          regno: "TN 09 A 8326",
          totalSeat: "12",
          filledSeat: "8",
          location: "Vijay Nagar"
        },
        {
          regno: "TN 14 A 4244",
          totalSeat: "12",
          filledSeat: "5",
          location: "Pallikaranai"
        },
      ]
    }


  ]
 
 
      
  constructor() { }

  ngOnInit(): void {
    this.openBookingSummary();
  
  }
       
  openBookingSummary(params: any = { 

  }) {
    const obj = {
    };

    
    if (params && params['search']){
      obj['search'] = params['search'];
    }

      obj['page'] = this.pageNum;
       obj['limit'] = 10;
  }

  pagination(type,term){
    if(type=='next'){
    
        this.pageNum++;
    
    }else if(type=='prev'){
      if(this.pageNum<=1) return;
      
       this.pageNum--;
    
    }
    this.openBookingSummary({search:term});

   }


  // search

  onSearchChange(searchValue: string) {

    searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

    if (!this.searchChangeObserver) {
      new Observable(observer => {
        this.searchChangeObserver = observer;
      }).pipe(debounceTime(500)) // wait 300ms after the last event before emitting last event
        .pipe(distinctUntilChanged()) // only emit if value is different from previous value
        .subscribe((term: any) => {
          // your code here

          this.openBookingSummary({search:term});
        });
    }

    this.searchChangeObserver.next(searchValue);
  }

  // chart_reportsCount: any = this.reportsData.vehicle;



}
